import { fetcher } from "services/api.service";
import useSWR from "swr";
import { LogisticsTicketVendor } from "types/logisticsTicket";

export default function useVendors() {
  const { data, isLoading } = useSWR<{ vendors: LogisticsTicketVendor[] }>("/vendors", fetcher);

  return { vendors: data?.vendors || [], isLoading };
}
